import { forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Typography, TypographyProps } from '@material-ui/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = () =>
  createStyles({
    root: {
      gridRow: '2',
    },
  });

export interface SidebarSectionDescriptionProps
  extends Omit<TypographyProps, 'classes'>,
    WithStyles<typeof styles> {}

const SidebarSectionDescription = forwardRef<
  HTMLElement,
  SidebarSectionDescriptionProps
>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <Typography
      ref={ref}
      variant="body2"
      color="textSecondary"
      className={classNames(className, classes.root)}
      {...rest}
    >
      {children}
    </Typography>
  );
});

SidebarSectionDescription.displayName = 'SidebarSection.Description';

export default withStyles(styles)(SidebarSectionDescription);
